import React from 'react';
import { CalendarDaysIcon, ShieldAlertIcon, SmartphoneIcon, NotebookPenIcon } from 'lucide-react';
import { instantAccessItems } from '../data/kit';
const icons = {
  calendar: CalendarDaysIcon,
  shield: ShieldAlertIcon,
  phone: SmartphoneIcon,
  notebook: NotebookPenIcon
};
export function InstantAccessSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-86" data-mp="1hmixaai5mxmr">
      <div className="max-w-4xl mx-auto text-center" data-id="element-87" data-mp="1wcgrb72rmhjv">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-88" data-mp="1wf317dd4p959">
          ¿Qué recibís al instante?
        </h2>

        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-89" data-mp="25deob5esdosy">
          {instantAccessItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.text} className="bg-white rounded-2xl p-5 flex items-center justify-center gap-3 shadow-sm border border-brand-creamDark/50" data-id="element-90" data-mp="20cr0stprnq3h">
                <Icon className="w-5 h-5 text-brand-greenDark shrink-0" aria-hidden="true" data-id="element-91" data-mp="62wyzjokebcm" />
                <span className="font-bold text-brand-text" data-id="element-92" data-mp="2s1t8vgmzln94">{item.text}</span>
              </li>;
        })}
        </ul>

        <p className="text-xl md:text-2xl font-serif italic text-brand-greenDeep font-bold" data-id="element-93" data-mp="2wyjm7w7eq4qu">
          Todo el material de tu año, en un solo enlace de descarga.
        </p>
      </div>
    </section>;
}